import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './views/login/login.component';
import { ForgotPasswordComponent } from './views/forgot-password/forgot-password.component';
import { ActivateAccountComponent } from './views/activate-account/activate-account.component';
import { OverviewComponent } from './views/overview/overview.component';
import { AuthGuard } from './guards/auth.guard';
import { NgModule } from '@angular/core';
import { TermsOfUseComponent } from './views/terms-of-use/terms-of-use.component';
import { RegisterBreederComponent } from './views/register-breeder/register-breeder.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'overview',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    pathMatch: 'full'
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'activate-user',
    component: ActivateAccountComponent
  },
  {
    path: 'reset-password',
    component: ActivateAccountComponent
  },
  {
    path: 'termsOfUse',
    component: TermsOfUseComponent
  },
  {
    path: 'register-breeder',
    component: RegisterBreederComponent
  },
  {
    path: 'overview',
    component: OverviewComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
